import moment from 'moment'
export const forms = {
  getBaseForm(formData, extend, pageType) {
    var moren = ''
    if (pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch') {
      moren = ''
    } else {
      moren = '--'
    }
    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const data = [
      {
        type: getType('examineForm_type', 'select'),
        label: '帮扶类别',
        rules: [
          {
            required: true,
            message: '请选择帮扶类别'
          }
        ],
        defaultValue: formData.examineForm_type || moren,
        options: [
          {
            label: '因病帮扶',
            value: '因病帮扶'
          },
          {
            label: '因残帮扶',
            value: '因残帮扶'
          },
          {
            label: '突发事件',
            value: '突发事件'
          },
          {
            label: '教育帮扶',
            value: '教育帮扶'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        col: '12',
        id: 'examineForm_type',
        layout: {
          labelCol: '140px'
        }
      },
      {
        type: getType('examineForm_instructions', 'textarea'),
        label: '家庭困难情况审核',
        rules: [
          {
            required: true,
            message: '请填写家庭困难情况审核'
          }
        ],
        col: '24',
        lineFeed: true,
        autoSize: { minRows: 5, maxRows: 20 },
        defaultValue: formData.examineForm_instructions || moren,
        id: 'examineForm_instructions',
        layout: {
          labelCol: '140px'
        }
      },
      {
        type: getType('examineForm_Enjoyed', 'textarea'),
        label: '已享受',
        col: '24',
        lineFeed: true,
        autoSize: { minRows: 5, maxRows: 20 },
        defaultValue: formData.examineForm_Enjoyed || moren,
        id: 'examineForm_Enjoyed',
        layout: {
          labelCol: '140px'
        }
      },
      {
        type: getType('examineForm_people', 'input'),
        label: '审核人',
        col: '12',
        lineFeed: true,
        rules: [
          {
            required: true,
            message: '请填写审核人'
          }
        ],
        defaultValue: formData.examineForm_people || moren,
        id: 'examineForm_people',
        layout: {
          labelCol: '140px'
        }
      },
      {
        type: getType('examineForm_time', 'datePicker'),
        label: '审核时间',
        // disabled: extend.checkDisabled,
        rules: [
          {
            required: true,
            message: '请选择审核时间'
          }
        ],
        lineFeed: true,
        format: 'YYYY-MM-DD',
        defaultValue: extend.checkDisabled('examineForm_time')
          ? formData.examineForm_time
            ? `${formData.examineForm_time}`
            : ''
          : formData.examineForm_time
            ? moment(formData.examineForm_time, 'YYYY-MM-DD')
            : null,
        col: '12',
        id: 'examineForm_time',
        layout: {
          labelCol: '140px'
        }
      }
      // {
      //   type: getType('individual_case_support_funds', 'input'),
      //   label: '帮助资金',
      //   col: '12',
      //   defaultValue: formData.individual_case_support_funds,
      //   onChange: (value) => { extend.checkFund(value, 'individual_case_support_funds') },
      //   lineFeed: true,
      //   id: 'individual_case_support_funds',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // }
    ]
    return data
  }
}
